// extracted by mini-css-extract-plugin
module.exports = {"color-white":"#fff","overlay":"LoadingOverlay_overlay__rmLQr","disabled":"LoadingOverlay_disabled__1Bh-P","loader":"LoadingOverlay_loader__1xyXU"};